import {CoreDI, LanguageService, lazyInject} from '@gongxigames/framework/core';
import {MessagePopupButton, MessagePopupData, MessageText} from '@gongxigames/framework/slot/types';
import {PopupObject, TemplateUtils} from '@gongxigames/framework/slot/services/TemplateUtils';

export class HTMLMessagePopup {
    @lazyInject(CoreDI.LanguageService)
    protected readonly languageService!: LanguageService;

    protected _params: MessagePopupData;
    protected _container!: HTMLDivElement;
    protected _popup!: HTMLDivElement;
    protected _content!: HTMLDivElement;
    protected TEMPLATE_NAME = 'popup';
    protected _popupObject!: PopupObject;
    protected _id = 'session-timer';

    public static createPopup(params: MessagePopupData): PopupObject {
        return new HTMLMessagePopup(params).popup;
    }

    constructor(params: MessagePopupData) {
        this._params = params;

        this.initContainer();
        this.initContent();
        this.initButtons();
        this.initPopupObject();
    }

    protected initContainer(): void {
        this._container = TemplateUtils.createHTMLDivElementByTemplate(this.TEMPLATE_NAME, {
            id: this._id,
            header: this.getText(this._params.title)
        });

        this._popup = this.getHTMLDivElementFromContainer(`#${this._id}`);

        if (this._params.withBorders) {
            this._popup.classList.add('with-borders');
        }
    }

    protected initContent(): void {
        this._content = this.getHTMLDivElementFromContainer(`#${this._id}-content`);
        this._content.innerHTML = this.getMessageTextElement();
    }

    protected initPopupObject(): void {
        const {closeButton} = this._params;
        const closeButtonElement = this.getHTMLDivElementFromContainer(`#${this._id}-close`);

        closeButtonElement.hidden = true;

        if (closeButton && closeButton.visible) {
            closeButtonElement.hidden = false;
            closeButtonElement.onclick = () => closeButton.onClick();
        }

        this._popupObject = {
            type: 2,
            popup: this._popup,
            parent: this._container,
            header: this.getHTMLDivElementFromContainer(`#${this._id}-title`),
            closeButton: closeButtonElement,
            content: this._content
        };
    }

    protected getMessageTextElement(): string {
        return `<p>${this.getText(this._params.message)}</p>`;
    }

    protected initButtons(): void {
        if (this._params.buttons?.length) {
            this._popup.classList.add('buttons');
            this._params.buttons?.forEach(this.addButton.bind(this));
        }
    }

    protected addButton(data: MessagePopupButton): void {
        const button = document.createElement('button');
        const {action, title} = data;

        button.textContent = this.getText(title);

        button.onclick = () => action();

        this._content.insertAdjacentElement('beforeend', button);
    }

    protected getHTMLDivElementFromContainer(selector: string): HTMLDivElement {
        return this._container.querySelector(`${selector}`) as HTMLDivElement;
    }

    public get popup(): PopupObject {
        return this._popupObject;
    }

    private getText(message?: MessageText): string {
        if (message) {
            return typeof message === 'string' ? message : this.languageService.get(message.id);
        }

        return '';
    }
}
